$(function(){
    console.log('Hello Ayni!');

    AYNI.init();
    AYNI_MODALS.init();
    AYNI_WEBSITES.init();
});

var AYNI = {
    init: function() {
        this.handleSamePageLiks();
    },
    handleSamePageLiks: function() {
        $('body').on('click', 'a[href!="#"]', function(event){
            var $target = $('#' + event.target.href.split('#')[1]);

            $('html, body').stop().animate({
                scrollTop: $target.offset().top,
            }, 700, 'swing');
        });
    },
    handleContactFormSubmition: function() {
        $('form').on('submit', function() {
            var $form = $(this);
            var $submitButton = $form.find('[type=submit]');
            var data  = $form.serialize();
            var type  = $form.attr('method');
            var url   = $form.attr('action');

            $submitButton.text('Sending...');

            $.ajax({
                type: type,
                url: url,
                data: data,
                done: function(response) {
                    $submitButton.text('Success!');
                    $submitButton.attr('disabled', 'disabled');
                    $submitButton.fadeOut();
                    $form.find('.form-successMessage').fadeIn();
                }
            });
        });
    }
}

var AYNI_MODALS = {
    init: function(){
        this.setUpTriggerEvents();
    },
    setUpTriggerEvents: function() {
        $('body').on('click', '[data-ayni-modal-trigger]', function(){
            $($(this).data('ayni-modal-target')).toggleClass('active');
            $('.main').toggleClass('blurred');
            $('body').toggleClass('no-overflow')
        });
    }
};

var AYNI_WEBSITES = {
    init: function() {
        this.setUpJiraIssueCollector();
        console.log('set up websites module');
    },
    setUpJiraIssueCollector: function() {
        console.log('before');
        // Requires jQuery!
        jQuery.ajax({
            url: "https://ayniteam.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/w34rg7/b/18/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=15f3f114",
            type: "get",
            cache: true,
            dataType: "script"
        });
        console.log('after');


        window.ATL_JQ_PAGE_PROPS =  {
			triggerFunction: function(showCollectorDialog) {
				jQuery("#jiraButton").click(function(e) {
                    console.log('clicked');
					e.preventDefault();
					showCollectorDialog();
				});
			}
		};
    }
};
